import * as React from "react";

function SvgChartbeat(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-5 -40 178 178.1"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="Chartbeat_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={482.995}
        y1={444.811}
        x2={485.252}
        y2={428.561}
        gradientTransform="translate(-392 -424)"
      >
        <stop offset={0.239} stopColor="#4a9ed7" />
        <stop offset={0.47} stopColor="#4397d2" />
        <stop offset={0.864} stopColor="#2c85c6" />
        <stop offset={1} stopColor="#217ec2" />
      </linearGradient>
      <path fill="url(#Chartbeat_svg__a)" d="M21 2.183v23h117.65l27.516-23z" />
      <linearGradient
        id="Chartbeat_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={459.607}
        y1={468.989}
        x2={461.458}
        y2={451.098}
        gradientTransform="translate(-392 -424)"
      >
        <stop offset={0.239} stopColor="#b4ddf3" />
        <stop offset={0.482} stopColor="#aad3ed" />
        <stop offset={0.895} stopColor="#90bddf" />
        <stop offset={1} stopColor="#89b7db" />
      </linearGradient>
      <path fill="url(#Chartbeat_svg__b)" d="M0 25.183v24h112.386l26.926-24z" />
      <g>
        <linearGradient
          id="Chartbeat_svg__c"
          gradientUnits="userSpaceOnUse"
          x1={464.181}
          y1={487.943}
          x2={465.973}
          y2={474.799}
          gradientTransform="translate(-392 -424)"
        >
          <stop offset={0.239} stopColor="#4fc2ba" />
          <stop offset={0.461} stopColor="#47b9b0" />
          <stop offset={0.839} stopColor="#33a69a" />
          <stop offset={1} stopColor="#289d90" />
        </linearGradient>
        <path
          fill="url(#Chartbeat_svg__c)"
          d="M36 49.183v23h49.134l27.252-23z"
        />
      </g>
      <path d="M168.539.866c-1.112-1.112-3.04-1.159-4.203-.101L56.747 98.76l-.163.149c-3.825 3.83-3.825 10.066 0 13.907a9.778 9.778 0 006.955 2.876c2.567 0 4.983-.972 6.903-2.836l98.195-107.79a3.037 3.037 0 00-.098-4.2z" />
    </svg>
  );
}

export default React.forwardRef(SvgChartbeat);
